<template>
  <button
    @click="toggleAvatar"
    :class="[custom]"
    class="group h-11 group rounded-full flex items-center relative cursor-pointer"
    :aria-label="$t('app.header_user_options', { user })"
    :disable="disable"
  >
    <div class="open-user-menu w-10/5 h-10/5 rounded-full flex items-center justify-center transition-all duration-100">
      <base-icon
        :name="setArrow"
        :class="{ 'transform rotate-180': isOpen }"
        class="group-hover:text-primary transition-transform duration-300"
        :title="isOpen ? $t('app.submenu_close') : $t('app.submenu_open')" 
      />
    </div>
    <el-tooltip 
      v-if="customText === ''" 
      v-model="tooltipVisible"
      :manual="true"
      placement="top" 
      :open-delay="750"
      >
      <div slot="content" :class="isLower1024 ? 'max-w-[18rem]' : ''"
        @mouseenter="tooltipVisible = true"
        @mouseleave="tooltipVisible = false"
      >{{ user }}</div>
      <span class="user-name-div truncate hidden md:block"
        @keydown.esc="tooltipVisible = false"
        @mouseenter="tooltipVisible = true"
        @mouseleave="tooltipVisible = false"
        @focus="tooltipVisible = true"
        @blur="tooltipVisible = false">
        {{ user }}
      </span>
    </el-tooltip>
    <div v-else class="user-name-div truncate hidden md:block">
      {{ customText }}
    </div>
    <div v-if="showAvatar" class="w-10/5 h-10/5 bg-primary-700 rounded-full overflow-hidden flex items-center justify-center">
      <base-icon 
        :name="role === 3 ? 'avatarsa' : 'avatar'"
        size="lg"
        class="group-hover:text-primary text-secondary dark:text-darkblue-200 dark:hover:bg-darkblue-600 hover:text-primary dark:hover:text-primary active:bg-primary-100 active:text-primary focus:bg-primary-100 focus:text-primary"
      />
    </div>
    <div v-else class="w-10/5 h-10/5 bg-primary-700 rounded-full overflow-hidden"/>
  </button>
</template>

<script>
export default {
  name: 'base-avatar',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    custom: {
      type: [Array, String],
      default: ''
    },
    onMobile: {
      type: Boolean,
      default: false
    },
    customText: {
      type: String,
      default: ''
    },
    showAvatar: {
      type: Boolean,
      default: true
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      tooltipVisible: false,
    }
  },
  computed: {
    setArrow: function () {
      return this.onMobile ? 'chevronup' : 'chevrondown'
    },
    user: function () {
      const user = this.$store.getters['auth/user']
      if (user === null || user === undefined) return ''
      else return user.Usuario
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isLower1024 () {
      return this.$store.getters['app/getIsLower1024']
    }
  },
  methods: {
    toggleAvatar: function () {
      this.$emit('toggleAvatar')
    }
  }
}
</script>

<style lang="scss" scoped>
.user-name-div {
  max-width: 200px;
}
</style>
